import { FaTimes } from 'react-icons/fa'
import Button from 'react-bootstrap/Button'

const CancelButton = (props) => {
    return (
        <Button variant="outline-primary" size="lg" className="mb-3" onClick={props.onClick}>
            <FaTimes /> Cancel
        </Button>
    )
}

export default CancelButton